
export const PAGE_LIST = [
    { label: "KPI Dashboard", value: "kpi-dashboard" },
    { label: "Machine MM", value: "machinemm" },
    { label: "Machine Status Dashboard", value: "machine-status" },
    { label: "Device OEE", value: "deviceoee" },
    { label: "Operator Performance", value: "operator-performance" },
    { label: 'Production overview', value: "production-overview" },
    { label: "Holiday Calendar", value: "holiday-list"},
    { label: "Operation Analytics", value: "analytics" },
    { label: "Insights", value: "insights" },
    { label: "Reports", value: "reports" },
    { label: "Operator Details", value: "operator-details" },
    { label: "Machines", value: "machines" },
    { label: "Machine Group", value: "machines-group" },
    { label: "Shift Registration", value: "shift-registration" },
    { label: "User Registration", value: "user-registration" },
    { label: "Group Registration", value: "group" },
    { label: "Component Registration", value: "component-registration" },
    { label: "Reason Registration", value: "reason-registration" },
    { label: "Settings", value: "settings" }
];

export const QUALITY_PAGELIST = [
    { label: "Quality Entry", value: "quality" },
    { label: "Blue Card", value: "bluecard" },
    { label: "Blue Card Report", value: "bluecardreport" },
    { label: "Reports", value: "reports" },
];